import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

import {
  StatementSearchRequest,
  StatementExportRequest,
  Statements,
  StatementDetails,
  InterventionType,
  TowingTypes,
} from '../models/statements.model';

@Injectable({
  providedIn: 'root',
})
export class StatementsService {
  apiUrl = environment.api.root;

  private readonly http: HttpClient = inject(HttpClient);

  constructor() {}

  getInterventionTypes(): Observable<InterventionType[]> {
    return this.http.get<InterventionType[]>(
      `${this.apiUrl}/Global/InterventionTypes`
    );
  }

  getTowingTypes(): Observable<TowingTypes[]> {
    return this.http.get<TowingTypes[]>(`${this.apiUrl}/Global/TowingTypes`);
  }

  searchStatements(request: StatementSearchRequest): Observable<Statements> {
    return this.http.post<Statements>(
      `${this.apiUrl}/Statements/Search`,
      request
    );
  }
  getAllStatements(): Observable<Statements> {
    return this.http.get<Statements>(`${this.apiUrl}/Statements`);
  }
  getPaginatedStatements(
    page: number = 1,
    size: number = 10
  ): Observable<Statements> {
    return this.http.get<Statements>(`${this.apiUrl}/Statements`, {
      params: {
        page: page.toString(),
        size: size.toString(),
      },
    });
  }
  getStatementById(id: string): Observable<StatementDetails> {
    return this.http.get<StatementDetails>(`${this.apiUrl}/Statements/${id}`);
  }
  exportToExcel(request: StatementExportRequest): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/Statements/Export/Excel`, request, {
      responseType: 'blob',
    });
  }
}
